export default "<app-core></app-core>";